export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/images/cs-logo.png" alt="Company Secretaries of India logo" className={`${className} object-contain bg-paper rounded-md p-1`} />
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="w-11 h-11 shrink-0" />
    <span className="leading-none">
      <span className="block font-display font-extrabold text-[17px] tracking-tight text-ink">
        Jay Kular <span className="text-[var(--brass-deep)]">&</span> Associates
      </span>
      <span className="block font-mono-x text-[10.5px] uppercase tracking-[0.18em] mt-1 text-ink/70">
        Company Secretaries
      </span>
    </span>
  </span>
);
